const SDK_VERSION = '7.61.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
